import type { TrailStep } from "../../../components/chrome/trail";

/** The firm's ledger is the admin's page: everyone else gets the section's name, not a link to a refusal. */
export function billingStep(isAdmin: boolean): TrailStep {
  return isAdmin ? { label: "Billing", to: "/billing" } : { label: "Billing" };
}
